import React from 'react';

const SubmitSection = ({ kvkkAccepted, onKvkkChange, onKvkkModalOpen, onSubmit, isSubmitting }) => {
  return (
    <div className="space-y-6">
      {/* KVKK Checkbox */}
      <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
        <div className="flex items-start">
          <input
            type="checkbox"
            id="kvkkAccept"
            checked={kvkkAccepted}
            onChange={(e) => {
              if (e.target.checked) {
                onKvkkModalOpen();
              } else {
                onKvkkChange(false);
              }
            }}
            className="mt-1 h-5 w-5 text-primary accent-primary border-gray-300 rounded focus:ring-primary cursor-pointer"
          />
          <div
            onClick={() => !kvkkAccepted && onKvkkModalOpen()}
            className="ml-3 flex-1 cursor-pointer"
          >
            <span className="text-sm text-gray-900">
              KVKK Aydınlatma Metnini okudum, anladım ve kişisel verilerimin işlenmesine onay veriyorum.
            </span>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onKvkkModalOpen();
              }}
              className="block mt-2 text-sm text-primary hover:text-primary-dark font-medium underline"
            >
              KVKK Metnini Görüntüle
            </button>
          </div>
        </div>
      </div>

      {/* Submit Button */}
      <button
        type="button"
        onClick={onSubmit}
        disabled={!kvkkAccepted || isSubmitting}
        className={`
          w-full py-4 px-6 rounded-lg font-semibold text-lg transition-all duration-200 shadow-lg flex items-center justify-center
          ${kvkkAccepted && !isSubmitting
            ? 'bg-primary text-white hover:bg-primary-dark hover:shadow-xl transform hover:-translate-y-0.5'
            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }
        `}
      >
        {isSubmitting ? (
          <>
            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Gönderiliyor...
          </>
        ) : (
          'Başvuruyu Gönder'
        )}
      </button>

      {!kvkkAccepted && (
        <p className="text-center text-sm text-gray-500">
          Başvurunuzu göndermek için KVKK metnini onaylamanız gerekmektedir.
        </p>
      )}
    </div>
  );
};

export default SubmitSection;
